import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import styles from './style.css';
import Heading from '../../components/Typography/Heading/Heading';
import TrusteeInformationSection from '../../components/PersonalInformationSection/TrusteeInformationSection';
import CoTrusteePISection from '../../components/PersonalInformationSection/CoTrusteePISection';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const TrusteeInformationScreen = () => {
  const { back, next, flowProps } = useContext(FlowContext);
  const { title = 'Enter Trustee Information' } = flowProps;

  return (
    <>
      <div className="container">
        <Heading text={title} />
        <TrusteeInformationSection />
        <CoTrusteePISection />
      </div>

      <div className="btn-container">
        <MFBeaconButton
          variant="primary"
          size="normal"
          id="trusteeInformationContinue"
          className="continue-btn"
          onClick={next()}
          label="Continue"
          data-name={generateGeneralTestID(
            'TrusteePersonalInformation',
            'ContinueButton'
          )}
        />
        <MFBeaconButton
          variant="secondary"
          size="normal"
          id="trusteeInformationBack"
          onClick={back()}
          label="Back"
          data-name={generateGeneralTestID(
            'TrusteePersonalInformation',
            'BackButton'
          )}
        />
      </div>

      <PhoneNumber />

      <style jsx>{styles}</style>
    </>
  );
};

export default TrusteeInformationScreen;
